'use client'

import React, {useContext} from 'react'

import {Context} from '../../../Header/Context'
import {useModalsContext} from '../../../hooks/useModalContext'
import type {TLink} from './Link'

type GoalLinkProp = Omit<TLink, 'href'> & {href: string}

export function GoalLink({onClick: onClickExternal, goal, ...linkProps}: GoalLinkProp) {
  const {href} = linkProps
  const {dispatch} = useModalsContext()
  const {reachGoal} = useContext(Context)

  return (
    <a
      onClick={e => {
        if (href?.toString().includes('$modal:')) {
          e.preventDefault()
          dispatch({type: 'setOpen', payload: href.toString().split(':')[1]})
        }

        goal && reachGoal?.(goal)
        onClickExternal?.(e)
      }}
      {...linkProps}
    />
  )
}
